/**
 * Option lists + EXAMPLE data for the Profile Activity windows. Copy matches the approved master
 * (profile-activity-v5.html) and the free-tier view (profile-activity-free.html).
 */
import type { NotebookNote, NotebookObservation } from '@pghbites/shared';

export const CUISINE_OPTIONS = [
  'Pizza', 'Italian', 'Wings', 'Sushi', 'BBQ', 'Tacos', 'Ramen', 'Diner breakfast',
  'Burgers', 'Thai', 'Indian', 'Seafood', 'Vegan', 'Sandwiches',
] as const;

export const DIETARY_OPTIONS = [
  'No cilantro', 'Vegetarian', 'Vegan', 'Gluten-free', 'No pork', 'Halal', 'Kosher', 'Nut allergy', 'Dairy-free',
] as const;

export const PRICE_OPTIONS = ['$', '$$', '$$$', '$$$$'] as const;

export const TEAM_OPTIONS = ['Steelers', 'Pens', 'Pirates', 'Pitt', 'Riverhounds'] as const;

export const REVIEW_VOICE_OPTIONS = ['Warm & simple', 'Funny neighbor', 'Straight facts'] as const;

/** Brockett voice dials — labels + the smallint key on member_preferences. */
export const VOICE_DIALS = [
  { key: 'voice_humor', label: 'humor' },
  { key: 'voice_local_pride', label: 'local pride' },
  { key: 'voice_formality', label: 'formality' },
  { key: 'voice_detail', label: 'detail' },
  { key: 'voice_adventure', label: 'adventure' },
] as const;

// ── EXAMPLE data shown to free members (stamped, dimmed, non-interactive) ─────────
export const EXAMPLE_DIALS: Record<string, number> = {
  voice_humor: 4, voice_local_pride: 5, voice_formality: 2, voice_detail: 3, voice_adventure: 4,
};

export const EXAMPLE_OBSERVATIONS: NotebookObservation[] = [
  { id: 'ex1', text: 'loves Gaucho on the Strip' },
  { id: 'ex2', text: 'usually eats near Carnegie' },
];

export const EXAMPLE_NOTES: NotebookNote[] = [
  { id: 'ex1', text: 'no pizza on weekends', added_at: '' },
  { id: 'ex2', text: 'no loud places, the baby', added_at: '' },
];

export const EXAMPLE_CUSTOM_VOICE = "Marty's no-BS, all-flavor take";
